<template>
  <div style="margin: 200px auto;">
    <form class="form-signin">

      <div class="form-label-group">
        <label for="signin-account">아이디</label>
        <input type="text" id="signin-account" name="signin-account" class="form-control"
               placeholder="Account"
               required="" autofocus=""
               v-validate="'required|min:5'"
               v-model="account"
               :class="{ 'is-invalid': errors.has('signin-account') }">
        <div v-if="errors.has('signin-account')" class="invalid-feedback">아이디를 입력하세요.</div>
      </div>

      <div class="form-label-group">
        <label for="signin-password">비밀번호</label>
        <input type="password" id="signin-password" name="signin-password" class="form-control"
               placeholder="Password"
               required=""
               v-validate="'required'"
               v-model="password"
               :class="{ 'is-invalid': errors.has('signin-password') }"
               @keyup.enter="signIn">

        <div v-if="errors.has('signin-password')" class="invalid-feedback">비밀번호를 입력하세요.</div>
      </div>

      <div class="checkbox mb-3" v-show="false">
        <label>
          <input type="checkbox" value="remember-me"> Remember me
        </label>
      </div>

      <p class="text-success text-center"
         v-if="signInError !== null">{{ signInError }}</p>

      <button class="btn btn-lg btn-primary btn-block my-3" type="button" @click="signIn">로그인
      </button>
      <p class="mt-5 mb-3 text-muted text-center">© 2019</p>
    </form>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AdminLogin',
  computed: {
    ...mapGetters(['token']),
  },
  data() {
    return {
      account: '',
      password: '',
      signInError: null,
    };
  },
  methods: {
    async signIn() {
      await this.$validator.validateAll();

      if (this.errors.any()) {
        return;
      }

      this.$axios.post('/api/login', {
        account: this.account,
        password: this.password,
      }).then(
        (res) => {
          console.log(res.data);
          this.$store.commit('setToken', res.data.token);
          this.$store.commit('setRefreshToken', res.data.refreshToken);

          this.$axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;

          this.$router.push({ name: 'adminMainList' });
        },
        (err) => {
          console.log(err);

          this.signInError = err.response.data.message || err.message;
        },
      );
    }
    ,
  }
  ,
};
</script>

<style scoped>


  .form-signin {
    width: 100%;
    max-width: 420px;
    padding: 15px;
    margin: auto;
  }


</style>
